import m, {Vnode} from "mithril";
import {Mark} from "../TextHighlighter";
import {Questionary} from "../../../model/questionary";

export default class TextHighlighterControls {

    private self: TextHighlighterControls;

    constructor(
        private questionary: Questionary,
        private mark: Mark = "positive",
    ) {
        this.self = this;
    }

    public get marker() {
        return this.self.mark;
    }

    public set marker(mark) {
        this.self.mark = mark;
    }

    public view(): Vnode {
        return m('.TextHighlighter-controls', {}, [
            m('div.control.success'+(this.marker==='positive'?'.active':''),{
                onclick: () => this.marker = 'positive'
            }, [
                m('i.icon.icon-thumb-up.success'),
            ]),
            m('div.control.danger'+(this.marker==='negative'?'.active':''),{
                onclick: () => this.marker = 'negative'
            }, [
                m('i.icon.icon-thumb-down.danger'),
            ]),
            m('div.control'+(this.marker==='none'?'.active':''), {
                onclick: () => this.marker = 'none'
            }, [
                m('i.icon.icon-eraser'),
                m('span', {}, this.questionary.messages.get('rubber'))
            ]),
        ]);
    }

}